import { events } from '@nykaa/data-layer/constants';
import { pushEvent } from '@nykaa/data-layer/utils';
import { isValidObject } from '@nykaa/utils/validations';
import { variantTypes } from 'shared/constants';
import { CategoryLevels, PrimaryCategories } from 'store/product/types';

export const isConfigurable = (type: string) =>
  type &&
  type.toUpperCase() !== variantTypes.SIMPLE &&
  type.toUpperCase() !== variantTypes.BUNDLE;

export const pushVideoPlay = (
  productId: string,
  positionInCarousel: number
) => {
  pushEvent(events.PRODUCT_VIDEO_PLAY, {
    productVideoPlay: `${productId}:${positionInCarousel}`,
  });
};

export const getCategoryId = (categoryLevels: CategoryLevels = {}) => {
  const categoryValues = Object.values(categoryLevels);
  const categoryArrayLength = categoryValues?.length;
  const categoryId = categoryValues[categoryArrayLength - 1];
  return categoryId;
};

export const getCatgoryLevelId = (primaryCategories: PrimaryCategories) => {
  if (isValidObject(primaryCategories)) {
    const categoryId = primaryCategories?.l3?.id || '';
    return categoryId;
  }
  return '';
};
